import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const sydneyClock = new Intl.DateTimeFormat("en-AU", {
  timeZone: "Australia/Sydney", weekday: "short", day: "2-digit", month: "short",
  year: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZoneName: "short",
});

export function checkpointSchedule(sessionDate, cutoffET) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(sessionDate || "") || !/^([01]\d|2[0-3]):[0-5]\d$/.test(cutoffET || "")) return null;
  const wallTime = `${sessionDate} ${cutoffET}`;
  const scheduled = dayjs.tz(wallTime, "America/New_York");
  if (!scheduled.isValid() || scheduled.format("YYYY-MM-DD HH:mm") !== wallTime) return null;
  const parts = sydneyClock.formatToParts(scheduled.toDate());
  const get = (type) => parts.find((part) => part.type === type)?.value;
  return {
    at: scheduled.valueOf(),
    sydney: `${get("weekday")} ${get("day")} ${get("month")} ${get("year")}, ${get("hour")}:${get("minute")} ${get("timeZoneName")}`,
  };
}


export const fmt = (n, d = 2) =>
  n === null || n === undefined || Number.isNaN(n) ? "—" : Number(n).toFixed(d);

export const fmtInt = (n) => (n === null || n === undefined ? "—" : Math.round(n).toLocaleString());

export const signed = (n, d = 2) => {
  if (n === null || n === undefined) return "—";
  const v = Number(n);
  return (v > 0 ? "+" : "") + v.toFixed(d);
};

export const sessionLabel = (session) => session.provider === "polygon"
  ? "LIVE · SPXW 0DTE (massive.com)"
  : session.scenario || session.fixture || "Source not recorded";

export function sessionReviewContext(date, run, now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hourCycle: "h23" }).formatToParts(now);
  const get = (type) => parts.find((part) => part.type === type)?.value;
  const today = `${get("year")}-${get("month")}-${get("day")}`;
  if (date && date < today) return "historical";
  if (run === 6 || (date === today && Number(get("hour")) >= 16)) return "post-close";
  return null;
}

export const decisionClass = (label) => {
  switch (label) {
    case "ENTER":
    case "ENTER PRE-OPEN":
      return "dec-green";
    case "WAIT":
    case "WAIT FOR OPEN":
      return "dec-amber";
    case "NO TRADE":
      return "dec-red";
    case "PROVISIONAL":
      return "dec-blue";
    default:
      return "dec-gray";
  }
};

export const RUN_META = {
  1: { time: "08:40", name: "PRE-MARKET BUILD" },
  2: { time: "09:20", name: "FINAL PRE-OPEN LOCK" },
  3: { time: "09:33", name: "OFFICIAL-OPEN RESET" },
  4: { time: "09:46", name: "15-MINUTE NOWCAST" },
  5: { time: "10:01", name: "30-MINUTE CONFIRMATION" },
  6: { time: "16:10", name: "POST-CLOSE SCORING" },
};

export const ruleTip = {
  L1: "Bid-ask per leg ≤ 10% of width AND ≤ $0.60",
  L2: "Both legs have positive, uncrossed bids; live quotes must be fresh, timestamped and same-session 0DTE",
  L3: "Short-strike OI ≥ 500 OR volume ≥ 200",
  L4: "Strikes within ±3% of spot",
  S1: "Fill = mid + 40% of half-spread (entry & exit)",
  S2: "$1.30/contract/leg fees",
  S3: "EV net of S1 & S2",
  E1: "Net EV ≥ +8% of max risk (12% if T3)",
  E2: "Debit: profit ≥ 1.2× loss / Credit: credit ≥ 20% width",
  E3: "P(profit) ≥ 40% debit / ≥ 65% credit (70% T3)",
  T1: "P(touch short) ≤ 35% for credits",
  T2: "Verified calendar required; no entry within 30 min of a high/medium-impact US release",
  "DATA-01": "Both legs need valid real-time NBBO, same-session expiry and quotes no older than 60 seconds",
  "KS-01": "Critical market input unavailable",
  "KS-02": "Session date, expiry or timezone integrity failure",
  "KS-06": "High-impact event pending during regular trading; forecast STALE",
  "EDGE": "All pinned conditions must match current evidence; older versions and unsupported or missing inputs block entry",
  KILL: "Kill switch active — entry refused",
  T3: "VIX1D up >15% escalates E1/E3",
  C1: "Path stable across last two checkpoints or OR-break w/ breadth",
  C2: "≥3 of 4 aligned with direction",
  C3: "No unresolved rates/oil vs price conflict",
  B1: "ENTER PRE-OPEN gate (conf≥90, EV≥1.5×E1, rarity)",
  B2: "ENTER gate (conf≥65, all L/S/E/T/C pass)",
};
